import { render } from "./ComponentUpload.vue?vue&type=template&id=dd76569e"
import script from "./ComponentUpload.vue?vue&type=script&lang=js"
export * from "./ComponentUpload.vue?vue&type=script&lang=js"

import exportComponent from "/Users/danielnogueira/hd/git/enuve/app-cliente/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__